import React from "react";
import { Hero } from "./components/Hero";
import { SocialProof } from "./components/SocialProof";
import { ProblemSection } from "./components/ProblemSection";
import { Presentation } from "./components/Presentation";
import { SystemsSection } from "./components/SystemsSection";
import { BonusesSection } from "./components/BonusesSection";
import { ValueStack } from "./components/ValueStack";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
export function App() {
  return <div className="min-h-full w-full bg-neutral-950 pb-24 text-white" data-id="element-0" data-mp="2wk9xqj754kyk">
      <main data-id="element-1" data-mp="2wi5nljineppu">
        <Hero data-id="element-2" data-mp="28ufmg62gz4gf" />
        <SocialProof data-id="element-3" data-mp="28tw4ipctkg2e" />
        <ProblemSection data-id="element-4" data-mp="28te3zgj4jfoo" />
        <Presentation data-id="element-5" data-mp="28sl5f2ubjwhm" />
        <SystemsSection data-id="element-6" data-mp="23vcjcr61v8b3" />
        <BonusesSection data-id="element-7" data-mp="23vul23bheeqe" />
        <ValueStack data-id="element-8" data-mp="23ujlygszdv5m" />
        <Guarantee data-id="element-9" data-mp="23v2uj6wqr76z" />
        <Testimonials data-id="element-10" data-mp="3ijxpcqos80jw" />
        <Faq data-id="element-11" data-mp="3ikhaeg9qb525" />
        <FinalCta data-id="element-12" data-mp="3iiwdwl3utc1n" />
      </main>
      <FloatingCta data-id="element-13" data-mp="3ijpd910hgz9r" />
    </div>;
}